// eslint-disable-next-line unicorn/prevent-abbreviations
export default class DevKtableController {
	/* @ngInject */
	constructor() {
		this.data = {
			options: {
				actions:     {
					insert:     true,
					refresh:    true,
					update:     true,
					updateCell: true,
				},
				height:      300,
				mode:        'normal',
				packet_size: 50,
			},
			query:   {
				select: [
					{
						inherits_extended: -1,
						kid:               'K_NODE;CIVILITY',
						linker_kid:        '0',
						name:              'Civilité',
						node:              'REPRE',
						op:                'detail',
						path:              [
							{ kid: 'K_NODE;PERSON', name: 'Personne', flow: null },
							{
								kid: 'K_NODE;CIVILITY', name: 'Civilité', flow: 'down', linker_kid: '0',
							},
						],
						type:              'K_NODE;STRING',
					},
					{
						inherits_extended: -1,
						kid:               'K_NODE;LASTNAME',
						linker_kid:        '0',
						name:              'Nom de famille',
						node:              'REPRE',
						op:                'detail',
						path:              [
							{ kid: 'K_NODE;PERSON', name: 'Personne', flow: null },
							{
								kid: 'K_NODE;LASTNAME', name: 'Nom de famille', flow: 'down', linker_kid: '0',
							},
						],
						type:              'K_NODE;STRING',
					},
					{
						inherits_extended: -1,
						kid:               'K_NODE;FIRSTNAME',
						linker_kid:        '0',
						name:              'Prénom',
						node:              'REPRE',
						op:                'detail',
						path:              [
							{ kid: 'K_NODE;PERSON', name: 'Personne', flow: null },
							{
								kid: 'K_NODE;FIRSTNAME', name: 'Prénom', flow: 'down', linker_kid: '0',
							},
						],
						type:              'K_NODE;STRING',
					},
					{
						inherits_extended: -1,
						kid:               'K_NODE;PROFESSION',
						linker_kid:        '0',
						name:              'Profession',
						node:              'REPRE',
						op:                'detail',
						path:              [
							{ kid: 'K_NODE;PERSON', name: 'Personne', flow: null },
							{
								kid: 'K_NODE;PROFESSION', name: 'Profession', flow: 'down', linker_kid: '0',
							},
						],
						type:              'K_NODE;STRING',
					},
					{
						inherits_extended: -1,
						kid:               'K_NODE;DATE',
						linker_kid:        'K_NODE;BIRTH',
						name:              'Date',
						node:              'REPRE',
						op:                'detail',
						path:              [
							{ kid: 'K_NODE;PERSON', name: 'Personne', flow: null },
							{
								kid:         'K_NODE;DATE',
								name:        'Date',
								flow:        'down',
								linker_kid:  'K_NODE;BIRTH',
								linker_info: { kid: 'K_NODE;BIRTH', name: 'Naissance' },
							},
						],
						type:              'K_NODE;STRING',
						linker_info:       { kid: 'K_NODE;BIRTH', name: 'Naissance' },
					},
					{
						inherits_extended: -1,
						kid:               'K_NODE;EMAIL',
						linker_kid:        '0',
						name:              'Email',
						node:              'REPRE',
						op:                'detail',
						path:              [
							{ kid: 'K_NODE;PERSON', name: 'Personne', flow: null },
							{
								kid: 'K_NODE;EMAIL', name: 'Email', flow: 'down', linker_kid: '0',
							},
						],
						type:              'K_NODE;STRING',
					},
				],
				from:   [
					{
						node:              'K_NODE;PERSON',
						name:              'Personne',
						type:              'K_NODE;STRING',
						inherits_extended: -1,
						path:              [{ kid: 'K_NODE;PERSON', name: 'Personne', linker_kid: '0' }],
					},
				],
				where:  {
					condition: 'AND',
					rules:     [
						{
							condition:  'NONE',
							field:      'K_NODE;LASTNAME',
							having:     null,
							id:         'K_NODE;LASTNAME',
							label:      'Nom de famille',
							operator:   'begins_with',
							path:       [
								{ kid: 'K_NODE;PERSON', name: 'Personne', flow: null },
								{
									kid: 'K_NODE;LASTNAME', name: 'Nom de famille', flow: 'down', linker_kid: '0',
								},
							],
							type:       'K_NODE;STRING',
							value:      'BE',
							linker_kid: '0',
						},
					],
				},
				date:   '_NOW_',
			},
		};
		this.ktable = {
			files:       {},
			forms:       {},
			submissions: {},
		};
		this.jsonEditorOptions = {
			mode:  'code',
			modes: [
				'code',
				'form',
				'text',
				'tree',
				'view',
			],
		};
	}
}
